import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Paginated } from '@sd-portal/shared/models';

import { AuditLogLite } from './+models/audit-log-lite.model';
import { RolesAuditRole } from './+models/roles-audit.model';

@Injectable()
export class RolesAuditService {
  private readonly apiUrl = '/sdapi/profile/audit/roles';

  constructor(private readonly http: HttpClient) {}

  private paginationParams(pageNumber: number, pageSize: number): HttpParams {
    return new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
  }

  getRoles(pageNumber: number, pageSize: number): Observable<Paginated<RolesAuditRole>> {
    return this.http.get<Paginated<RolesAuditRole>>(this.apiUrl, {
      params: this.paginationParams(pageNumber, pageSize)
    });
  }

  getRoleLogs(
    roleId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<Paginated<AuditLogLite>> {
    return this.http.get<Paginated<AuditLogLite>>(`${this.apiUrl}/${roleId}/logs`, {
      params: this.paginationParams(pageNumber, pageSize)
    });
  }
}
